import { Injectable } from '@angular/core';
import { Deserialize, Serialize } from 'cerialize';
import moment from 'moment-timezone';
import { CacheExpiryConstants } from '../constants';
import { isNullOrUndefined } from '../utils/util';
import { CachedData } from './cached-data';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  getCachedData(key: string): string {
    const cachedDataString: string = localStorage.getItem(key);

    if (isNullOrUndefined(cachedDataString)) {
      return null;
    }

    try {
      const cachedData: CachedData = Deserialize(JSON.parse(cachedDataString), CachedData);

      // Check cache expiration and remove/return null if expired
      if (isNullOrUndefined(cachedData) || isNullOrUndefined(cachedData.expiry) || cachedData.expiry.getTime() <= new Date().getTime()) {
        this.removeCachedData(key);
        return null;
      }

      return cachedData.data;
    } catch (err) {
      /* istanbul ignore next */ {
        this.removeCachedData(key);
        return null;
      }
    }
  }

  cacheData(key: string, data: string, expirationMinutes = CacheExpiryConstants.DEFAULT_CACHE_EXPIRY) {
    const cachedData = new CachedData();
    cachedData.data = data;
    cachedData.expiry = moment().add(expirationMinutes, 'minutes').toDate();
    localStorage.setItem(key, JSON.stringify(Serialize(cachedData)));
  }

  removeCachedData(key: string) {
    localStorage.removeItem(key);
  }
}
